import React from "react";
import style from "./NufolksTeam.module.css";
// import { TeamMember1, TeamMember2, TeamMember3, TeamMember4, TeamMember5, TeamMember6, TeamMember7, TeamMember8, TeamMember9, TeamMember10, TeamMember11 } from "../../assets";
import {Ellipse1, Ellipse2, Wallet} from "../../assets";
import { getEmployeesList } from "../../api/containersApi";
import { useQuery } from  "@tanstack/react-query";

export default function NufolksTeam(){

    const { data: employeesList } = useQuery({
        queryKey: ["getEmployeesList"],
        queryFn: () => getEmployeesList({auth_key: localStorage.getItem("sessionToken")})
    });

    return(
        <div className={style.NufolksTeam_container}>
            
            <img src={Ellipse1} className={style.ornament1} alt="Ellipse1" />
            <h1>Meet the Minds Behind the Magic</h1>
            <p>Get to know the passionate professionals who bring creativity, innovation, and expertise together to make extraordinary ideas come to life.</p>

            <div className={style.NufolksTeam_slideshow_section}>
                <section className={style.slider}>
                    {
                        employeesList?.map((item, index) => {
                          return(
                            <div className={style.TeamMemberImage_container}>
                                <img src={item?.profilePicture} alt="image" />
                            </div>
                          );
                        })
                    }
                </section>
                <section className={style.slider}>
                    {
                        employeesList?.map((item, index) => {
                          return(
                            <div className={style.TeamMemberImage_container}>
                                <img src={item?.profilePicture} alt="image" />
                            </div>
                          );
                        })
                    }
                </section>
            </div>
            <img src={Ellipse2} className={style.ornament2} alt="Ellipse2" />
        </div>
    );
}